<template>
  <div class="good">
    <div class="bg">
      <div class="container">
        <div class="title">
          <p class="item">{{shopname}}</p>
          <p class="item">表白商店</p>
        </div>
        <div class="goodslist">
          <ul class="infos">
            <li class="lis" v-for="(item,index) in goodsList" :key="index">
              <div class="image">
                <img :src="item.goodsImg" alt>
              </div>
              <div class="right">
                <p class="goodsname">{{item.goodsName}}</p>
                <div class="info">
                  <span class="price">
                    <span></span>
                    {{item.price}}
                  </span>
                  <p class="btn" @click="getCustomer(item)">
                    <img src="../../../assets/images/active/goumai.png" alt>
                    <span>查看购买人</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <div class="yaoqing">
          <span class="info">快点让其他人来购买你的商品吧</span>
        </div>
        <div class="share" @click="share">
          <p class="sharebtn">分享</p>
        </div>
      </div>
      <div class="motailin" v-show="isApp">
        <div class="title">
          <p class="item">{{message}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      message:"",
      isApp:"",
      shopname: "",
      goodsList: [],
      goodsId: "",
      isQrcode:false,
      isapp: false,
      token:"",
      userguid:""

    };
  },
  created() {
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
      setTimeout(() => {
      this.$bridge.callhandler(
        {
          action: "get",
          object: "userinfo"
        },
        res => {
          const jsonObj = JSON.parse(res);
          this.token = jsonObj.token;
          this.userguid = jsonObj.userguid;
          this.nickname = jsonObj.nickname;
          this.$store.dispatch('Token',this.token)
          localStorage.setItem("token",this.token)
          this.$store.dispatch('UserGuid',this.userguid)
          localStorage.setItem('userguid',this.userguid)
          this.$store.dispatch("NickName",this.nickname)
          // this.$store.dispatch("nickname",this.nickname)
          this.isapp = true
          // 网络请求调用
          this.getBuyList();
        }
      );
    }, 3000);
    if(this.token || this.userguid){
      this.$router.push({path:"/login"})
    }
     // 网络请求调用 测试用 后要删除
    this.getBuyList();
  },
  methods: {
    getCustomer(item) {
      this.$router.push({ path: "/customer", query: { id: item.goodsId } });
    },
    getBuyList() {
      axios
        .post(this.$interfaces.getUserActivityLoveShop, {
          userGuid:this.$store.state.userguid,
          token:this.$store.state.token,
          ownerUserGuid:this.$store.state.userguid
        })
        .then(res => {
          console.log(res);
          if(res.data.code == 400){
            this.$router.push({ path: "/login" });
            return
          }
          this.goodsList = res.data.data.goodsList;
          if( this.goodsList.length <= 0){
            this.$router.push({ path: "/start" });
          }
          this.shopname = res.data.data.shopName;
          this.shopid=res.data.data.ownerUserGuid
          console.log(this.shopid)
        })
        .catch(err => {
          console.log(err);
        });
    },
    share() {
      this.appShare()
    },
     appShare() {
       if(!this.isapp){
         //仅支持app 内部分享
          this.isApp=true
        this.message="仅支持在我是谜app内分享"
         setTimeout(()=>{
            this.isApp=false
        this.message="仅支持在我是谜app内分享"
         },3000)
        
       }
      this.$bridge.callhandler({
        action: "open",
        object: "share",
        param: {
          title: "我把自己上架到表白商店了,来【我是谜】买我,520我陪你过,一定陪你过",
          desc: "520我陪你过,一定陪你过",
          image:
            "https://woshimiimage.mvoicer.com/image/item/showImg/1546842407308?imageMogr2/thumbnail/300x300",
          url: "https://wtm.mvoicer.com/otherhome/"+this.shopid //172.20.10.2  //wtm.mvoicer.com
        }
      })
    },
  }
};
</script>

<style scoped>
.good {
  width: 100%;
  height: 100%;
}
.good .bg {
  background: url("../../../assets/images/active/bg/bgmyhome.png") no-repeat
    left top;
  background-size: cover;
  height: 33.35rem;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
}
.good .bg .container {
  padding-left: 2.125rem;
  padding-right: 2.125rem;
  position: absolute;
  top: 2.97rem;
  text-align: center;
  /* border: 0.025rem solid red; */
}

.good .bg  .motailin{
  position: absolute;
  bottom:2%;
  width: 8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background:rgba(255,255,255,0.9);
  border-radius: 0.5rem;
}
.good .bg .container .title {
  width: 14.5rem;
  text-align: center;
  font-size: 0.95rem;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: rgba(255, 57, 113, 1);
  margin-bottom: 1.475rem;
}
.good .bg .container .goodslist .infos .lis {
  position: relative;
  width: 16rem;
  height: 4.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  display: flex;
}
.good .bg .container .goodslist .infos .lis:last-child {
  margin-bottom: 0;
}
.good .bg .container .goodslist .infos .lis .image {
  flex: 0 0 3rem;
  width: 3rem;
  height: 3rem;
  border: 0.025rem solid #ccc;
  margin-right: 1rem;
}
.good .bg .container .goodslist .infos .lis .image img {
  width: 100%;
  height: 100%;
}

.good .bg .container .goodslist .infos .lis .right .goodsname {
  position: absolute;
  text-align: left;
  height: 1.25rem;
  /* line-height: 1.25rem; */
  color: rgba(117, 86, 98, 1);
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  /* border-bottom: 0.025rem solid #ccc; */
}

.good .bg .container .goodslist .infos .lis .right .info {
  position: absolute;
  bottom: 0.75rem;
  padding-top: 1.25rem;
  height: 1.3rem;
  background: yellow;
}
.good .bg .container .goodslist .infos .lis .right .info .price {
  position: absolute;
  bottom: 0;
  font-size: 1.05rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 66, 118, 1);
  line-height: 0.7rem;
}
.good .bg .container .goodslist .infos .lis .right .info .price span {
  color: rgba(255, 66, 118, 1);
  font-size: 0.6rem;
}
.good .bg .container .goodslist .infos .lis .right .info .btn {
  position: absolute;
  left: 5.625rem;
  bottom: 0;
  width: 4.6rem;
  height: 1.3rem;
}
.good .bg .container .goodslist .infos .lis .right .info .btn span {
  position: absolute;
  left: 0;
  bottom: 0.3rem;
  width: 4.6rem;
  height: 1.3rem;

  font-size: 0.6rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.good .bg .container .goodslist .infos .lis .right .info .btn img {
  width: 100%;
  height: 100%;
}
.good .bg .btn {
  position: absolute;
  bottom: 1.65rem;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.good .bg .btn .mocen {
  position: absolute;
  width: 16rem;
  height: 3rem;
  left: 0;
  top: 0;
  /* background:pink; */
}
.good .bg .btn .font {
  position: absolute;
  top: 0;
  left: 0;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.good .bg .btn img {
  width: 100%;
  height: 100%;
}
.good .bg .footer {
  position: absolute;
  bottom: 3.45rem;
  width: 16rem;
  height: 1.7rem;
  /* border:0.025rem solid #ccc; */
}
.good .bg .footer .yaoqing {
  float: left;
  width: 11.5rem;
  background: rgba(255, 255, 255, 1);
  opacity: 0.3;
  height: 1.7rem;
  border-radius: 0.85rem;
}
.good .bg .footer .yaoqing .info {
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 61, 115, 1);
  line-height: 1.7rem;
}
.good .bg .footer .share {
  float: right;
  width: 4rem;
  height: 1.7rem;
  background: rgba(255, 64, 117, 1);
  border-radius: 0.85rem;
}
.good .bg .footer .share .sharebtn {
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 1.7rem;
  text-align: center;
}
.good .bg .motail{
   position: fixed;
    width:100%;
    height:33.35rem;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0.5rem;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center
}

</style>





// WEBPACK FOOTER //
// src/components/active/view/home.vue